import { render, staticRenderFns } from "./SaleSearch.vue?vue&type=template&id=5b792f0b"
import script from "./SaleSearch.vue?vue&type=script&lang=ts"
export * from "./SaleSearch.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports